module.exports = __webpack_public_path__ + "img/ereszkalkulator_haz_nyeregteto_szines.94ee47d1.png";